import theme from '../common/utilsClient/theme';

export default theme;
